module.exports = __webpack_public_path__ + "static/media/icon-edit-active.23e5f175.svg";